module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "billNo"
    }
  }, [_vm._v("Bill No:")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.UnsettledData !== undefined ? _vm.UnsettledData.billNo : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "salesDate"
    }
  }, [_vm._v("Date:")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput"
  }, [_c('b', [_vm._v(_vm._s(_vm.UnsettledData !== undefined ? _vm.UnsettledData.salesDateNepali : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "WarehouseName"
    }
  }, [_vm._v("Payment method:")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.UnsettledData !== undefined ? _vm.UnsettledData.paymentMethod : '') + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "WarehouseName"
    }
  }, [_vm._v("Contact Number")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.UnsettledData !== undefined ? _vm.UnsettledData.contactNumber : '') + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "billprefix"
    }
  }, [_vm._v("Bill Prefix")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.UnsettledData !== undefined ? _vm.UnsettledData.billPrefix : '') + " ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered "
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.UnsettledData !== undefined ? _vm.UnsettledData.childSalesDetailsDTOList : ''), function(pd, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.itemName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.sellingPrice))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.sizeDetails))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((pd.quantity * pd.sellingPrice).toFixed(4)) + " ")])])])
  })], 2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('b', {
    staticStyle: {
      "margin-left": "12em"
    }
  }, [_vm._v(_vm._s(_vm.UnsettledData.childSalesDetailsDTOList[_vm.UnsettledData.childSalesDetailsDTOList.length - 1].sumQty))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('b', {
    staticStyle: {
      "margin-left": "12em"
    }
  }, [_vm._v(_vm._s(_vm.UnsettledData.childSalesDetailsDTOList[_vm.UnsettledData.childSalesDetailsDTOList.length - 1].sumAmount))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    attrs: {
      "for": "subttotal"
    }
  }, [_vm._v("Remarks: ")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.UnsettledData !== undefined ? _vm.UnsettledData.remarks : '') + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "subttotal"
    }
  }, [_vm._v("Delivery Address: ")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.UnsettledData !== undefined ? _vm.UnsettledData.deliveryAddress : '') + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "subttotal"
    }
  }, [_vm._v("Delivery Amount: ")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.UnsettledData !== undefined ? _vm.UnsettledData.deliveryAmount : '') + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "subttotal"
    }
  }, [_vm._v("Sub-Total: ")]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "subttotal"
    }
  }, [_vm._v(" " + _vm._s(_vm.UnsettledData !== undefined ? _vm.UnsettledData.subTotalAmount : 0) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "discountAmt"
    }
  }, [_vm._v("Discount Amt:")]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "discountAmt"
    }
  }, [_vm._v(_vm._s(_vm.UnsettledData !== undefined ? _vm.UnsettledData.discountAmt : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "nontaxable"
    }
  }, [_vm._v("Non-taxable:")]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "nontaxable"
    }
  }, [_vm._v(_vm._s(_vm.UnsettledData !== undefined ? _vm.UnsettledData.nonTaxableAmount : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "taxable"
    }
  }, [_vm._v("Taxable:")]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "taxable"
    }
  }, [_vm._v(_vm._s(_vm.UnsettledData !== undefined ? _vm.UnsettledData.taxableAmount : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "tax"
    }
  }, [_vm._v("Tax(13%):")]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "tax"
    }
  }, [_vm._v(_vm._s(_vm.UnsettledData !== undefined ? _vm.UnsettledData.vatAmount : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "total"
    }
  }, [_vm._v("Total:")]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "total"
    }
  }, [_vm._v(_vm._s(_vm.UnsettledData !== undefined ? _vm.UnsettledData.billAmount : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "tenderAmt"
    }
  }, [_vm._v("Tender Amount:")]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "tenderAmt"
    }
  }, [_vm._v(_vm._s(_vm.UnsettledData !== undefined ? _vm.UnsettledData.tenderAmount : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "returnAmt"
    }
  }, [_vm._v("Return Amount:")]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "returnAmt"
    }
  }, [_vm._v(_vm._s(_vm.UnsettledData !== undefined ? _vm.UnsettledData.returningAmount : 0))])])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-danger ",
    attrs: {
      "label": "Back"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.back()
      }
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Item Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Rate")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Size")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Amount")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('b', {
    staticStyle: {
      "margin-left": "15em"
    }
  }, [_vm._v("Total:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a9b1b5b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/pos/posUnsettledDetails.vue
// module id = 2067
// module chunks = 0